import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { STUDENT_NAV_TABS } from "../../constants/studentNavTabs";

const DEFAULT_PROFILE_IMAGE =
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80";

const StudentMobileProfileSidebar = ({ open, onClose, loggedInUser }) => {
  const location = useLocation();

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  return (
    <>
      <div
        className={`fixed inset-0 z-[60] bg-black/30 transition-opacity duration-300 sm:hidden ${
          open ? "opacity-100" : "pointer-events-none opacity-0"
        }`}
        onClick={onClose}
        aria-hidden={!open}
      />

      <aside
        className={`fixed right-0 top-0 z-[70] flex h-screen w-full max-w-[360px] flex-col bg-white shadow-[-8px_0_24px_rgba(0,0,0,0.12)] transition-transform duration-300 ease-in-out sm:hidden ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        aria-hidden={!open}
      >
        <div className="flex items-center justify-between border-b border-[#E9EAF0] px-5 py-4">
          <h2 className="text-lg font-semibold text-[#1D2026]">Profile</h2>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full p-1.5 text-[#1D2026] transition-colors hover:bg-[#F5F5F5]"
            aria-label="Close profile menu"
          >
            <X size={22} />
          </button>
        </div>

        <div className="border-b border-[#E9EAF0] px-5 py-6">
          <div className="flex items-center gap-4">
            <div className="h-20 w-20 shrink-0 overflow-hidden rounded-full">
              <img
                src={loggedInUser?.profilePicture || DEFAULT_PROFILE_IMAGE}
                alt="Student profile"
                className="h-full w-full object-cover"
              />
            </div>

            <div className="min-w-0">
              <h3 className="truncate text-xl font-semibold text-[#1D2026]">
                {loggedInUser?.firstName || "Student"}{" "}
                {loggedInUser?.lastName || ""}
              </h3>
              <p className="mt-1 truncate text-sm text-[#6E7485]">
                {loggedInUser?.email || "student@email.com"}
              </p>
            </div>
          </div>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-4">
          <ul className="space-y-1">
            {STUDENT_NAV_TABS.map((tab) => {
              const isActive = location.pathname === tab.path;

              return (
                <li key={tab.path}>
                  <Link
                    to={tab.path}
                    onClick={onClose}
                    className={`block rounded-lg px-4 py-3 text-base font-semibold transition-colors ${
                      isActive
                        ? "bg-[#FF6636] text-white"
                        : "text-[#1D2026] hover:bg-[#F5F5F5]"
                    }`}
                  >
                    {tab.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default StudentMobileProfileSidebar;
